<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="cache_list"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="buttons"
            :addButton="{ enabled: false, permission: 'default' }"
            :deleteButton="{ permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @ClearCache="ClearCache"
        >
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="clearAll">一键清理</el-button>
            </template>
        </crud-facecade>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `Cache`,
    data() {
        return {
            title: `缓存清理`,
            cache_list: [],
            url: {
                baseURL: `/api/AcisSystem/SysUser`,
                get: () => {
                    return new Promise(resolve => {
                        this.myaxios.get(`/api/Anonymous/CacheServer/GetCache`).then(data => {
                            let r = _.filter(data, d => {
                                return _.startsWith(d, `Meehealth.Acis.Entities.`)
                            }).map(d => {
                                return {
                                    name: d.replace(/（.+）/, ``),
                                    content: d
                                }
                            })
                            this.cache_list = r
                            resolve(r)
                        })
                    })
                }
            },
            buttons: [
                {
                    label: `清理`,
                    type: `primary`,
                    emit: `ClearCache`,
                    permission: `default`
                }
            ]
        }
    },
    created() {},
    computed: {
        ...mapGetters([`enum_menus`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    // width: "240",
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `content`,
                    label: `内容`,
                    // width: "600",
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: false,
                    sortable: true
                }
            ]
        }
    },
    methods: {
        ClearCache({ row }) {
            let that = this
            let req = that.myaxios.delete(`/api/Anonymous/CacheServer/InvalidCache`, { key: _.trim(row.name) })
            req.then(data => {
                that.$message.success(`清理成功`)
                that.$refs.cache_list.ReloadListData()
            })
        },
        clearAll() {
            let that = this
            that.$confirm(`警告`, {
                title: `警告`,
                message: `确定清理所有缓存?系统使用期间清理缓存可能导致系统宕机，需要回收程序池，请谨慎操作！`,
                confirmButtonText: `清理缓存`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                let reqs = this.cache_list.map(d => {
                    return this.myaxios.delete(`/api/Anonymous/CacheServer/InvalidCache`, { key: _.trim(d.name) })
                })
                this.myaxios.all(...reqs).then(() => {
                    that.$message.success(`清理成功`)
                    that.$refs.cache_list.ReloadListData()
                })
            })
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cache.vue